import React from 'react'
import { Route } from 'react-router'
import AppContainer from './containers/App'
import HelpHome from './containers/HelpHome/HelpHome'
import ProductCare from './containers/ProductCare/ProductCare'
import BreakdownCare from './containers/ProductCare/BreakdownCare'
import FurnitureCare from './containers/ProductCare/FurnitureCare'
import JewelleryCare from './containers/ProductCare/JewelleryCare'
import MonthlyCare from './containers/ProductCare/MonthlyCare'
import ReplacementCare from './containers/ProductCare/ReplacementCare'
import ContactUs from './containers/ContactUs/ContactUs'
import Nectar from './containers/Nectar/Nectar'
import ArgosCard from './containers/ArgosCard/ArgosCard'
import ManageArgosCard from './containers/ManageArgosCard/ManageArgosCard'
import CreditOffers from './containers/CreditOffers/CreditOffers'
import Page from './containers/Page/Page'
import FAQs from './containers/FAQs/FAQ'
import Search from './containers/FAQs/Search'

// Used on the server side to determine which component to render
export const routes = (
  <Route component={AppContainer} >
    <Route path='/help' component={HelpHome} />
    <Route path='/help/search/:searchTerm(/:pageNumber)' component={Search} />
    <Route path='/help/faq/:faqId' component={FAQs} />
    <Route path='/help/contact-us' component={ContactUs} />
    <Route path='/help/product-care' component={ProductCare} />
    <Route path='/help/breakdown-care' component={BreakdownCare} />
    <Route path='/help/furniture-care' component={FurnitureCare} />
    <Route path='/help/jewellery-watch-care' component={JewelleryCare} />
    <Route path='/help/monthly-care' component={MonthlyCare} />
    <Route path='/help/replacement-care' component={ReplacementCare} />
    <Route path='/help/argos-card' component={ArgosCard} />
    <Route path='/help/argos-card/manage' component={ManageArgosCard} />
    <Route path='/help/argos-card/credit-offers' component={CreditOffers} />
    <Route path='/help/nectar' component={Nectar} />
    <Route path='/help/:pageId' component={Page} />
  </Route>
)

// Used on the client side to prevent transition to pages before their data has loaded
export default (store) => {
  return (
    <Route component={AppContainer} >
      <Route path='/help' component={HelpHome} />
      <Route path='/help/search/:searchTerm(/:pageNumber)' component={Search} onEnter={Search.waitForDataClient(store)} />
      <Route path='/help/faq/:faqId' component={FAQs} onEnter={FAQs.waitForDataClient(store)} />
      <Route path='/help/contact-us' component={ContactUs} />
      <Route path='/help/product-care' component={ProductCare} onEnter={ProductCare.waitForDataClient(store)} />
      <Route path='/help/breakdown-care' component={BreakdownCare} onEnter={BreakdownCare.waitForDataClient(store)} />
      <Route path='/help/furniture-care' component={FurnitureCare} onEnter={FurnitureCare.waitForDataClient(store)} />
      <Route path='/help/jewellery-watch-care' component={JewelleryCare} onEnter={JewelleryCare.waitForDataClient(store)} />
      <Route path='/help/monthly-care' component={MonthlyCare} onEnter={MonthlyCare.waitForDataClient(store)} />
      <Route path='/help/replacement-care' component={ReplacementCare} onEnter={ReplacementCare.waitForDataClient(store)} />
      <Route path='/help/argos-card' component={ArgosCard} onEnter={ArgosCard.waitForDataClient(store)} />
      <Route path='/help/argos-card/manage' component={ManageArgosCard} onEnter={ManageArgosCard.waitForDataClient(store)} />
      <Route path='/help/credit-offers' component={CreditOffers} onEnter={CreditOffers.waitForDataClient(store)} />
      <Route path='/help/nectar' component={Nectar} onEnter={Nectar.waitForDataClient(store)} />
      <Route path='/help/:pageId' component={Page} onEnter={Page.waitForDataClient(store)} />
    </Route>
  )
}
